/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigBatchResponse {
    getFixupPrototypeFunction() { return LockConfigBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<LockConfigBatchResponse>): LockConfigBatchResponse {
        let obj = Object.assign(new LockConfigBatchResponse(), model);
        LockConfigBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigBatchResponse>): LockConfigBatchResponse {
        if (!model) return null;
        return LockConfigBatchResponse.newInstance(<LockConfigBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigBatchResponse) {
        if (!obj) return;

        models.LockConfigBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigBatchResponse): boolean {
        Object.setPrototypeOf(obj, LockConfigBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.LockConfigDetails.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.LockConfigDetails; };

}
